const filters = {
  classify(type) {
    switch (type) {
      case "capacity_g":
        return "重量";
      case "capacity_ml":
        return "容量";
      case "color":
        return "色号";
      case "collection":
      case "collection_sku":
        return "规格";
      default:
        return type;
    }
  },
  strLength(str, length) {
    if (!str || String(str).length <= length) return str;
    return String(str).substr(0, length);
  },
  toFixed(i, length) {
    if (isNaN(i)) return i;
    return parseFloat(i).toFixed(length);
  }
};

export default (Vue) => {
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
  });
}